import { Fragment, ReactElement, useContext, useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'
import { clamp, formatNumber } from 'Utils'
import { ArrowIcon } from './ArrowIcon'
import CloseIcon from './CloseIcon'
import possibleDialectValuesPerLocation from 'Assets/possibleDialectValuesPerLocation.json'
import Button from 'components/Button'
const ToolTip: React.FC<{
  activeData: any
  isClosable?: boolean
  hasShadow?: boolean
  closePressed?: () => void
}> = ({ activeData, isClosable, hasShadow, closePressed }): ReactElement => {
  const toolTipRef = useRef<HTMLDivElement>(null)
  return (
    <ToolTipWrapper ref={toolTipRef} hasShadow={hasShadow}>
      {activeData && (
        <>
          <Head>
            <h4>
              {activeData.location}{' '}
              <Percentage>
                {Math.round(activeData.averageScore * 1000) / 10}%
              </Percentage>
            </h4>
            {isClosable && (
              <ClosingButton
                className='close-button'
                onClick={(e) => {
                  e.stopPropagation()
                  closePressed?.()
                }}
              >
                <CloseIcon />
              </ClosingButton>
            )}
          </Head>
        </>
      )}
    </ToolTipWrapper>
  )
}
const Head = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1em;
  margin-bottom: 0;
  h4 {
    font-size: 1.5em;
    margin: 0;
    margin-bottom: 0.75em;
  }
`
const Percentage = styled.span`
  font-weight: 400;
`
const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1em;
  margin-top: 0;
`
const Row = styled.div`
  display: flex;
`
const EntryTitle = styled.b`
  color: ${(props) => props.color};
  min-width: 30px;
  font-size: 1.2em;
`
const EntryValue = styled.span<{ color: string }>``
const ClosingButton = styled.button`
  pointer-events: all;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.5rem;
  border: none;
  background-color: transparent;
  // disable flashing when pressing button
  -webkit-tap-highlight-color: transparent;
  color: inherit;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: var(--color-black);
    color: var(--color-white);
  }
`
const RelChange = styled.div<{ change: number }>`
  display: flex;
  /* justify-content: flex-end; */
  align-items: center;
  flex-direction: row;
  color: ${(props) =>
    props.change > 0
      ? 'var(--change-color-red)'
      : props.change < 0
      ? 'var(--change-color-green)'
      : 'currentColor'};
  .arrow-icon {
    transition: all 500ms cubic-bezier(0.77, 0, 0.175, 1);
    width: 1em;
    height: 1em;
    margin-right: 0.5em;
    margin-left: 0.5em;
  }
`
const ToolTipWrapper = styled.div<{ hasShadow?: boolean }>`
  pointer-events: none;
  background-color: var(--tooltip-background-color);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  font-size: 14px;
  box-shadow: rgba(0, 0, 0, 0.03) 0px 4.5px 1.3px,
    rgba(0, 0, 0, 0.035) 0px 8.6px 3.1px, rgba(0, 0, 0, 0.035) 0px 12.7px 5.5px,
    rgba(0, 0, 0, 0.04) 0px 17.3px 9.2px, rgba(0, 0, 0, 0.04) 0px 23.4px 15.1px,
    rgba(0, 0, 0, 0.047) 0px 33.5px 26.4px, rgba(0, 0, 0, 0.07) 0px 60px 57px;
  font-family: var(--font-plex);
  /* min-width: 250px;
  max-width: 400px; */
  animation: slide-in-top 0.3s ease-in-out;
  @keyframes slide-in-top {
    0% {
      transform: translate3d(0, -50px, 0);
      opacity: 0;
      max-height: 0;
    }
    100% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
      max-height: 400px;
    }
  }
`
export default ToolTip
